import { render } from "./RestaraceJidloVariantaInput.vue?vue&type=template&id=64b4ebd8"
import script from "./RestaraceJidloVariantaInput.vue?vue&type=script&lang=js"
export * from "./RestaraceJidloVariantaInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__